import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=134840c2&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"
import style0 from "./IconBase.vue?vue&type=style&index=0&id=134840c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134840c2",
  null
  
)

export default component.exports